import src from '../assets/bunkerswv-dark.png';
import { imageLogo } from './imageLogo';

export const BunkersWvDarkLogo = imageLogo({
  src,
  width: 513,
  height: 240,
  alt: 'Bunkers',
});
